var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPixelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2 0L6 0C7.10472 0 8 0.89528 8 2L8 6C8 7.10472 7.10472 8 6 8L2 8C0.89528 8 0 7.10472 0 6L0 2C0 0.89528 0.89528 0 2 0L2 0Z",
    fill: "#525AFF",
    transform: "translate(8 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 0L6 0C7.10472 0 8 0.89528 8 2L8 6C8 7.10472 7.10472 8 6 8L2 8C0.895281 8 0 7.10472 0 6L0 2C0 0.89528 0.895281 0 2 0L2 0Z",
    fill: "#FFEB52",
    transform: "translate(16 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 0L6 0C7.10472 0 8 0.895281 8 2L8 6C8 7.10472 7.10472 8 6 8L2 8C0.89528 8 0 7.10472 0 6L0 2C0 0.895281 0.89528 0 2 0L2 0Z",
    fill: "#FF5252",
    transform: "translate(8 16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 0L6 0C7.10472 0 8 0.89528 8 2L8 6C8 7.10472 7.10472 8 6 8L2 8C0.89528 8 0 7.10472 0 6L0 2C0 0.89528 0.89528 0 2 0L2 0Z",
    fill: "#7AFF52",
    transform: "translate(0 8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelIcon);
export default __webpack_public_path__ + "static/media/pixel_icon.ab80c04aba103736a658b4e87989d034.svg";
export { ForwardRef as ReactComponent };